
<div v-if="open" class="flow-modalbox-container">
	<div class="flow-modalbox-overlay" />
	<div class="flow-modalbox" :style="modalStyle">
		<div v-if="$slots['header']" class="flow-modalbox-header">
			<slot name="header" />
		</div>
		<div class="flow-modalbox-body">
			<slot />
		</div>
		<div v-if="$slots['footer']" class="flow-modalbox-footer">
			<slot name="footer" />
		</div>
	</div>
</div>
